"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.unenrollGrowthCustomer = exports.enrollGrowthCustomer = exports.getGrowthCustomerProfile = void 0;
const shared_1 = require("@getgreenline/shared");
const profilePath = ({ gatewayUrl, merchantId }, customerId) => `${gatewayUrl}/loyalty/api/v1/merchants/${merchantId}/customers/${customerId}/profile`;
/** Per-customer enrollment sub-resource: POST enrolls, DELETE unenrolls. */
const enrollmentPath = (request, customerId) => `${profilePath(request, customerId)}/enrollment`;
const isRecord = (value) => typeof value === 'object' && value !== null;
const asString = (value) => (typeof value === 'string' ? value : '');
/** The icon arrives either as a bare URL or as an object carrying one. */
const parseTierIconUrl = (icon) => {
    if (typeof icon === 'string') {
        return icon || null;
    }
    return isRecord(icon) && typeof icon.url === 'string' && icon.url ? icon.url : null;
};
/** Tiers are nested under `tier.current`; anything without a name is treated as absent. */
const parseTier = (tier) => {
    const current = isRecord(tier) ? tier.current : undefined;
    if (!isRecord(current) || typeof current.name !== 'string') {
        return null;
    }
    return {
        name: current.name,
        color: asString(current.color),
        textColor: asString(current.textColor),
        iconUrl: parseTierIconUrl(current.icon),
    };
};
const MALFORMED_PROFILE = 'Malformed Growth profile response';
const parseProfile = (data) => {
    if (!isRecord(data)) {
        throw new Error(MALFORMED_PROFILE);
    }
    const { availablePoints } = data;
    if (typeof availablePoints !== 'number' || !Number.isFinite(availablePoints)) {
        throw new Error(MALFORMED_PROFILE);
    }
    return {
        availablePoints,
        tier: parseTier(data.tier),
    };
};
const getGrowthCustomerProfile = ({ gatewayUrl, merchantId, customer, }) => __awaiter(void 0, void 0, void 0, function* () {
    const { id: customerId } = customer, pii = __rest(customer, ["id"]);
    const response = yield shared_1.axios.get(profilePath({ gatewayUrl, merchantId }, customerId), {
        params: pii,
    });
    return parseProfile(response.data);
});
exports.getGrowthCustomerProfile = getGrowthCustomerProfile;
const enrollGrowthCustomer = ({ gatewayUrl, merchantId, customerId, enrollment, }) => __awaiter(void 0, void 0, void 0, function* () {
    yield shared_1.axios.post(enrollmentPath({ gatewayUrl, merchantId }, customerId), enrollment);
});
exports.enrollGrowthCustomer = enrollGrowthCustomer;
const unenrollGrowthCustomer = ({ gatewayUrl, merchantId, customerId, }) => __awaiter(void 0, void 0, void 0, function* () {
    yield shared_1.axios.delete(enrollmentPath({ gatewayUrl, merchantId }, customerId));
});
exports.unenrollGrowthCustomer = unenrollGrowthCustomer;
//# sourceMappingURL=api.js.map